import '@flowable/forms/flwforms.min.css';

import { QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
import { queryClient } from './services/queryClient';

const rootElement = document.getElementById('root')!;

// NOTE: due to Flowable Form, we need to disable StrictMode
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>,
  );
}
